/**
 *
 * ROUTERS
 *
 */
import React from 'react';
import Loadable from 'react-loadable';

const Loading = () => <span>Loading...</span>;

export const HomePage = Loadable({
  loader: () => import('../components/templates/HomePage'),
  loading: Loading,
});

export const AttributionPage = Loadable({
  loader: () => import('../containers/templates/Attribution'),
  loading: Loading,
});

export const ManageUsers = Loadable({
  loader: () => import('../containers/templates/ManageUsers'),
  loading: Loading,
});

export const TransactionPage = Loadable({
  loader: () => import('../containers/templates/TransactionPage'),
  loading: Loading,
});

export const SubscriptionRedemption = Loadable({
  loader: () => import('../containers/templates/SubscriptionRedemption'),
  loading: Loading,
});

export const Dashboard = Loadable({
  loader: () => import('../containers/templates/Dashboard'),
  loading: Loading,
});
export const FundDashboard = Loadable({
  loader: () => import('../containers/templates/FundDashboard'),
  loading: Loading,
});
export const ReDashboard = Loadable({
  loader: () => import('../containers/templates/ReDashboard'),
  loading: Loading,
});

export const FundPerformance = Loadable({
  loader: () => import('../containers/templates/FundPerformance'),
  loading: Loading,
});

export const FundPrice = Loadable({
  loader: () => import('../containers/templates/FundPrice'),
  loading: Loading,
});

export const ClientPerformance = Loadable({
  loader: () => import('../containers/templates/ClientPerformance'),
  loading: Loading,
});

export const Reporting = Loadable({
  loader: () => import('../containers/templates/Reporting'),
  loading: Loading,
});

export const HoldingPage = Loadable({
  loader: () => import('../containers/templates/Holdings'),
  loading: Loading,
});
export const HoldingsDCIO = Loadable({
  loader: () => import('../containers/templates/HoldingsDCIO'),
  loading: Loading,
});

export const CashAndOnaPage = Loadable({
  loader: () => import('../containers/templates/CashAndOna'),
  loading: Loading,
});

export const About = Loadable({
  loader: () => import('../containers/templates/About'),
  loading: Loading,
});
export const AboutChild = Loadable({
  loader: () => import('../containers/templates/About/AboutChild'),
  loading: Loading,
});

export const RoutesDemo = Loadable({
  loader: () => import('../containers/templates/RoutesDemo'),
  loading: Loading,
});
export const Address = Loadable({
  loader: () => import('../containers/templates/RoutesDemo/Address'),
  loading: Loading,
});
export const BasicDetails = Loadable({
  loader: () => import('../containers/templates/RoutesDemo/BasicDetails'),
  loading: Loading,
});
export const Confirmation = Loadable({
  loader: () => import('../containers/templates/RoutesDemo/Confirmation'),
  loading: Loading,
});
export const Declaration = Loadable({
  loader: () => import('../containers/templates/RoutesDemo/Declaration'),
  loading: Loading,
});
export const Registration = Loadable({
  loader: () => import('../containers/templates/RoutesDemo/Registration'),
  loading: Loading,
});
export const Login = Loadable({
  loader: () => import('../components/templates/Login'),
  loading: Loading,
});

export const Logout = Loadable({
  loader: () => import('../components/templates/Logout'),
  loading: Loading,
});

export const ForgotPassword = Loadable({
  loader: () => import('../containers/templates/ForgotPassword'),
  loading: Loading,
});

export const ResetPassword = Loadable({
  loader: () => import('../containers/templates/ResetPassword'),
  loading: Loading,
});

export const LegalInformation = Loadable({
  loader: () => import('../containers/templates/LegalConnect'),
  loading: Loading,
});

export const Adhocfaq = Loadable({
  loader: () => import('../containers/templates/Adhocfaqconnect'),
  loading: Loading,
});

export const FAQ = Loadable({
  loader: () => import('../containers/templates/FAQConnect'),
  loading: Loading,
});
export const PrivacyPolicy = Loadable({
  loader: () => import('../containers/templates/PrivacyPolicyConnect'),
  loading: Loading,
});
export const TermsAndConditions = Loadable({
  loader: () => import('../containers/templates/TermsAndConditionConnect'),
  loading: Loading,
});
export const TermsAndConditionsCa = Loadable({
  loader: () => import('../containers/templates/TermsAndConditionCaConnect'),
  loading: Loading,
});

export const ChangePassword = Loadable({
  loader: () => import('../containers/templates/ChangePassword'),
  loading: Loading,
});

export const PersonalDetails = Loadable({
  loader: () => import('../containers/templates/PersonalDetails'),
  loading: Loading,
});

export const AddEditUser = Loadable({
  loader: () => import('../containers/templates/AddEditUser'),
  loading: Loading,
});

export const HelpAndSupport = Loadable({
  loader: () => import('../containers/templates/HelpAndSupport'),
  loading: Loading,
});

export const SchemeSelection = Loadable({
  loader: () => import('../components/templates/SchemeSelection'),
  loading: Loading,
});

export const TitleAndTerms = Loadable({
  loader: () => import('../components/templates/Login/TitleAndTerms'),
  loading: Loading,
});

export const HandlerError = Loadable({
  loader: () => import('../components/templates/HandlerError'),
  loading: Loading,
});

export const UserPreReg = Loadable({
  loader: () => import('../components/templates/UserPreReg'),
  loading: Loading,
});

export const SessionTimeOutModal = Loadable({
  loader: () => import('../components/templates/SessionTimeOutModal'),
  loading: Loading,
});
// export const ErrorPage = Loadable({
//   loader: () => import('../components/organisms/PageErrorContainer'),
//   loading: Loading,
// });

export const EmailVerification = Loadable({
  loader: () => import('../containers/templates/EmailVerification'),
  loading: Loading,
});

export const UnregisterUserList = Loadable({
  loader: () => import('../containers/templates/UnregisterUserList'),
  loading: Loading,
});

export const PasswordPolicy = Loadable({
  loader: () => import('../containers/templates/PasswordPolicyConnect'),
  loading: Loading,
});
